import { FormProvider } from "react-hook-form";
import { EmailIcon } from "@/components/shared/icons";
import { InputFormControl } from "@/components/shared/input-form-control";
import { FormInputPhoneNumber } from "@/components/shared/input-phone-number/controlled";
import { Typography } from "@/components/shared/typography";
import { Button, Input, View } from "@/components/ui";
import type { SignUpFormData, SignUpFormReturn } from "@/store/auth/forms/useSignUpForm";

import { ErrorMessage } from "../../error-message";

export const SignUpForm = ({
  onSubmitForm,
  loading,
  errorMessage,
  signUpFormReturn,
}: {
  loading?: boolean;
  errorMessage?: string;
  signUpFormReturn: SignUpFormReturn;
  onSubmitForm: (data: SignUpFormData) => void;
}) => {
  const {
    control,
    handleSubmit,
    formState: { isSubmitted, isSubmitting, isValid },
  } = signUpFormReturn;
  const onSubmit = handleSubmit(onSubmitForm);
  const SignUpMessage = () => (
    <ErrorMessage
      errorMessage={
        <View>
          <Typography variant="body-md">
            Account already exists. We've sent an OTP to your number for verification
          </Typography>
          <Typography variant="body-md" className="cursor-pointer" onClick={() => {}}>
            Verify OTP and Login
          </Typography>
        </View>
      }
    />
  );

  return (
    <FormProvider {...signUpFormReturn}>
      <InputFormControl
        control={control}
        name="firstName"
        label="First Name"
        component={Input}
        componentProps={{
          placeholder: "Enter Your First Name",
        }}
      />

      <InputFormControl
        control={control}
        name="lastName"
        label="Last Name"
        component={Input}
        componentProps={{
          placeholder: "Enter Your Last Name",
        }}
      />

      <InputFormControl
        control={control}
        name="email"
        label="Email"
        component={Input}
        componentProps={{
          placeholder: "youremail@example.com",
          prefix: <EmailIcon className="size-5" />,
        }}
      />

      <FormInputPhoneNumber name="phoneNumber" label="Phone Number" />

      {isSubmitted && (
        <ErrorMessage
          errorMessage={
            errorMessage === "Account already exists" ? <SignUpMessage /> : errorMessage
          }
          className="mt-4"
        />
      )}

      <Button
        loading={loading}
        onClick={onSubmit}
        variant="primary"
        color="CTA"
        rounded="full"
        className="mb-4 mt-4"
        disabled={!isValid || isSubmitting}
        children="Sign Up"
      />
    </FormProvider>
  );
};
